import { Text, Button, Checkbox, ComboBox, Label, MessageBar, MessageBarType, PrimaryButton, Stack, Toggle, IComboBoxOption } from '@fluentui/react';
import * as React from 'react';
import { IAttendee } from '../../../Models/Attendees/IAttendee';
import { getAge } from '../../../Tools/DateTime';
import { maxAgeOdchod } from '../../../App/Consts'
interface INewOrderStepOtherInformationProps {
    attendees: IAttendee[];
    goToStep: (step: number) => void;
    isAuth: boolean;
    goBack: () => void;
    acceptPromotion: boolean;
    acceptMarketing: boolean;
    setAcceptPromotion: (value: boolean) => void;
    setAcceptMarketing: (value: boolean) => void;
    updateDoprovodAttendee: (id: number, value: string) => void;
}

const odchod: IComboBoxOption[] = [
    {
        key: "samostatně",
        text: "samostatně",
    },
    {
        key: "v doprovodu",
        text: "v doprovodu",
    }
]

const checkboxStyle = {

    label: {
        color: 'black',
        fontFamily: '"Segoe UI"'
          }, text: { color: 'black' }

}

export const NewOrderStepOtherInformation: React.FunctionComponent<INewOrderStepOtherInformationProps> = (props) => {

    const [isIndeterminateAcceptPromotion, setIsIndeterminateAcceptPromotion] = React.useState(true);
    const [isIndeterminateAcceptMarketing, setIsIndeterminateAcceptMarketing] = React.useState(true);

    const acceptConditions = () => {
        return (<Stack tokens={{ childrenGap: 15 }}>
            <Checkbox required={true}
                styles={checkboxStyle}
                boxSide="end"
                label="Můžeme použít vaše osobní údaje pro propagační aktivity?"
                indeterminate={isIndeterminateAcceptPromotion}
                checked={props.acceptPromotion}
                defaultChecked={true}
                onChange={(e, checked) => {
                    props.setAcceptPromotion(checked ? checked : false)
                    setIsIndeterminateAcceptPromotion(false);
                }}
            />
            <Checkbox
                styles={checkboxStyle}
                required
                boxSide="end"
                label="Můžeme použít vaše osobní údaje pro přímý marketing?"
                indeterminate={isIndeterminateAcceptMarketing}
                checked={props.acceptMarketing}
                defaultChecked={true}
                onChange={(e, checked) => {
                    props.setAcceptMarketing(checked ? checked : false)
                    setIsIndeterminateAcceptMarketing(false);
                }
                } 
            />
        </Stack>
        )
    }

    const check = (): boolean => {

        let checkDoprovod = true;
        for (let i = 0; i < props.attendees.length; i++) {
            const item = props.attendees[i];

            if (getAge(item.dateOfBirth) < maxAgeOdchod && (item.doprovod === undefined || item.doprovod === "")) {
                checkDoprovod = false;
                break;
            }
        }
        return !isIndeterminateAcceptPromotion && !isIndeterminateAcceptMarketing && checkDoprovod;
    }

    const doprovodRender = () => {

        return (<Stack tokens={{ childrenGap:10 }} styles={{}}>
            {props.attendees.map(item => {
                if (getAge(item.dateOfBirth) < maxAgeOdchod) {
                    return <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign="center" >
                        <Text>{item.firstName + " " + item.lastName} bude odcházet </Text>
                        <ComboBox styles={{ root: { width: 140 } }} selectedKey={item.doprovod} onChange={(e, o, i, v) => props.updateDoprovodAttendee(item.id, o?.key ? o.key as string : "")} options={odchod} label="" />
                        <Text>po skončení kurzu</Text>
                    </Stack>
                }
            })}
        </Stack>);
    }



    return (<Stack tokens={{ childrenGap: 15 }} >
        <Stack horizontalAlign="start" styles={{ root: { maxWidth: 400 } }}>
            <h2>Ještě pár posledních drobností</h2>
        </Stack>
        <Stack tokens={{ childrenGap: 40 }}>
        {doprovodRender()}
        {acceptConditions()}
        </Stack>
        {!check() ?
            <MessageBar messageBarType={MessageBarType.warning} >Před pokračováním nám prosím odpovězte na otázky</MessageBar>
            : null}
        <Stack horizontal wrap tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: 40 } }}>
            <Button text="< Zpět" onClick={props.goBack} />
            <PrimaryButton disabled={!check()} text="Pokračovat >" styles={{ root: { width: 200 } }} onClick={() => props.goToStep(6)} />
        </Stack>

    </Stack>)
}
